import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Lakes serve numerous functions, including nutrient recycling,
              water purification, flood mitigation, erosion control, and
              providing habitat. However, population growth, rapid urbanization,
              and industrial development in Bangalore have led to the discharge
              of untreated domestic sewage, industrial effluents, and
              agricultural run-offs (fertilizers, insecticides), which have been
              posing serious threats to these ecosystems. The Bangalore Lakes
              Information System (BLIS) is designed based on the monitoring of
              175 lakes in Hebbal-Nagavara, Koramangala-Challaghatta, and
              Vrishabhavathi watersheds and their biodiversity (microalgae,
              zooplankton, ichthyofauna, macrophytes, and birds). Rapid
              urbanization in Bangalore has contributed to changes in wetland
              hydrology, catchment area loss, habitat loss, increased run-off,
              flooding instances, pollution, land encroachment, and overuse of
              resources. The aquatic biodiversity of Bangalore is under threat
              due to pollution, habitat loss, the introduction of exotic
              species, overexploitation, the extinction of native species, and
              other anthropogenic activities. The bioaccumulation of
              contaminants, particularly heavy metals, has contributed to
              contamination in the food chain or food web. Even though lakes
              provide various ecosystem goods and services, their quality is
              deteriorating mainly due to the sustained inflow of untreated
              wastewater (of nutrients, organic matter, and heavy metals), which
              would affect the health of aquatic life and the dependent
              population. Geographic Information System (GIS) technology is used
              to map surface water bodies and biodiversity. Thus, integrating
              GIS and web-based spatial decision support system (SDSS)
              technologies helps understand the status of lakes and devise
              strategies for prudent management and conservation of wetlands.
              BLIS empowers policymakers and other stakeholders to make informed
              decisions to protect ecologically, economically, and socially
              significant wetlands.
            </p>
            <p>
              <strong>Statement and Declarations</strong>
            </p>
            <p>
              <strong>Acknowledgments: </strong>We thank the EIACP-ENVIS
              Division, The Ministry of Environment, Forests and Climate Change,
              the Government of India, and the Indian Institute of Science
              (IISc) for their sustained support of ecological research. We are
              grateful to Sudarshan P for field sampling and macrophyte
              identification and to local fishermen who helped during fish
              sampling and provided local use information.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
